import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function SocialYoutube({ idVariant = '', className }: Props) {
  return (
    <IconBase name="social-youtube" w={16} className={className}>
      <g clipPath={`url(#socialyoutube_${idVariant}_clip0_13_370)`}>
        <path
          d="M15.6655 3.75069C15.4811 3.06185 14.9398 2.52052 14.2509 2.33613C13.0037 2.00159 8 2.00159 8 2.00159C8 2.00159 2.99639 2.00159 1.7491 2.33613C1.06026 2.52052 0.518935 3.06185 0.334542 3.75069C1.00141e-07 4.99797 0 7.60187 0 7.60187C0 7.60187 1.00141e-07 10.2058 0.334542 11.4531C0.518935 12.1419 1.06026 12.6832 1.7491 12.8676C2.99639 13.2021 8 13.2021 8 13.2021C8 13.2021 13.0037 13.2021 14.2509 12.8676C14.9398 12.6832 15.4811 12.1419 15.6655 11.4531C16.0001 10.2058 16.0001 7.60187 16.0001 7.60187C16.0001 7.60187 15.9987 4.99797 15.6655 3.75069Z"
          fill="currentColor"
        />
        <path d="M6.39844 10.0013L10.5552 7.60154L6.39844 5.20178V10.0013Z" fill="white" />
      </g>
      <defs>
        <clipPath id={`socialyoutube_${idVariant}_clip0_13_370`}>
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </IconBase>
  )
}

export default SocialYoutube
